const PUBLIC_TAGS = [
  'temperature_constant', 'temperature_normal', // temperature
  'upto_40ft', "upto_10t", "upto_4t", "upto_2t", // truck sizes
  'structure_non-wooden', 'structure_wooden', // structure
  'saturdays', 'sundays', 'holidays',
  'deliveryservice',
  'property_port', 'property_bonded'
];

export default {
  methods: {
    filterPublicTags (tags) {
      return tags.filter(tag => PUBLIC_TAGS.includes(tag));
    }
  }
}